<template>
  <el-table
    :data="opportunities"
    stripe
  >
    <el-table-column
      v-if="!!$scopedSlots['peek']"
      type="expand"
    >
      <template v-slot="{ row }">
        <slot
          name="peek"
          :opportunity="row"
        />
      </template>
    </el-table-column>

    <el-table-column
      label="Opportunity"
      prop="account"
      show-overflow-tooltip
    >
      <template v-slot="{ row }">
        <RouterLink :to="{ name: 'sales-opportunities-account', params: { accountId: $_.get(row, 'account.id') } }">
          {{ $_.get(row, 'account.name', '-') }}
        </RouterLink>
      </template>
    </el-table-column>

    <el-table-column
      label="Worth"
      prop="worth"
      :formatter="(row, col, cellValue) => cellValue ? `$${cellValue}` : '-'"
    />

    <el-table-column
      label="Portfolio"
      prop="portfolio"
      :formatter="row => $_.get(row, 'portfolio.long', '-')"
    />

    <el-table-column label="Status">
      <template v-slot="{ row }">
        <el-tag
          size="mini"
          :type="getTagTypeByStatus(row.status)"
        >
          {{ row.status | titleize }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column
      v-if="!!$scopedSlots['actions']"
      label="Actions"
      align="left"
    >
      <template v-slot="{ row }">
        <slot
          name="actions"
          :opportunity="row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    opportunities: {
      type: Array,
      required: true
    }
  },
  methods: {
    getTagTypeByStatus (status) {
      switch (status) {
        case 'working on':
          return undefined
        case 'awaiting decision':
        case 'pending':
          return 'warning'
        case 'trading':
          return 'success'
        case 'lost':
          return 'danger'
        default:
          return 'info'
      }
    }
  }
}
</script>
